import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { PoweredByComponentsInterface } from "../types/poweredByComponents.interface"

export class PoweredBy extends Component<{}, PoweredByComponentsInterface> {
    @handleComponentError("PoweredBy")
    render() {
        this.show(!!this.props.isVisible)
        super.render()
    }
}
